import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {generateUrl, routes} from "helpers/routes";
import InputFormGroup from "components/Form/InputFormGroup";
import {Button, Alert} from "reactstrap";
import Formsy from 'formsy-react';
import Loading from "components/Loading";

class Login extends React.Component {
    static propTypes = {
        onFormSubmit: PropTypes.func.isRequired,
        status: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.node.isRequired,
        }),
        loading: PropTypes.bool,
    };

    componentWillMount() {
        this.setState({
            formValid: false,
        })
    }

    render() {
        const {loading, onFormSubmit, status} = this.props;

        return (
            <div>
                <h1>
                    <strong>Placene</strong>volani.cz
                </h1>
                <p className="lead">
                    <FormattedMessage id="registration.motto" defaultMessage="Provide your services"/>.
                </p>

                <Formsy onValidSubmit={onFormSubmit} onValid={() => this.setState({formValid: true})}
                        onInvalid={() => this.setState({formValid: false})} className="form">
                    <div className="btn-group btn-group-register mb-4" role="group">
                        <Link to={generateUrl(routes.registration)} className="btn btn-outline-primary">
                            <FormattedMessage id="nav.registration" defaultMessage="Register"/>
                        </Link>
                        <Link to={generateUrl(routes.login)} className="btn btn-outline-primary active">
                            <FormattedMessage id="nav.login" defaultMessage="Login"/>
                        </Link>
                    </div>

                    <InputFormGroup type="email" name="email" id="email" required
                                    label={(<FormattedMessage id="registration.email_label" defaultMessage="E-mail"/>)}
                    />
                    <InputFormGroup type="password" name="password" id="password" required
                                    label={(
                                        <FormattedMessage id="registration.password_label" defaultMessage="Password"/>)}
                    />

                    <Link to={generateUrl(routes.forgottenPassword)}><FormattedMessage id="login.forgotten_password" defaultMessage="Forgot your password?"/></Link><br/><br/>

                    {status &&
                    <Alert color={status.type}>
                        {status.message}
                    </Alert>
                    }

                    <Button disabled={!this.state.formValid || loading} type="submit" block className="btn-clickable">
                        {loading &&
                        <span className="pr-3">
                            <Loading inline small/>
                        </span>
                        }
                        <FormattedMessage id="login.form.submit" defaultMessage="Log in"/>
                    </Button>
                </Formsy>
            </div>
        )
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/containers/Login/Login.jsx